import type { Vacancy } from 'clients/AutoCompleteClient/types';
import type { EnrichTab } from '../EditEnrichedVacancyForm/EditEnrichedVacancy.types';

export enum EnrichVacancyModalState {
  ChoosingCreationMethod = 'choosing-creation-method',
  WaitingToEnrichVacancy = 'waiting-to-enrich-vacancy',
  EnrichingVacancy = 'enriching-vacancy',
  EditingEnrichedVacancy = 'editing-enriched-vacancy',
}

export enum EnrichVacancyModalType {
  Ats = 'ats',
  Indeed = 'indeed',
}

export type EnrichVacancyModalContextProps = {
  state: EnrichVacancyModalState;
  modalType: EnrichVacancyModalType;
  vacancy: Vacancy | null;
  editVacancyTab: EnrichTab;

  setState: (state: EnrichVacancyModalState) => void;
  setVacancy: (vacancy: Vacancy | null) => void;
  setEditVacancyTab: React.Dispatch<React.SetStateAction<EnrichTab>>;
};
